'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVaasApp = exports.isManagerApp = exports.isMarketplaceApp = exports.isCreatorApp = exports.isProducerApp = exports.isContentManagerApp = exports.isBrandApp = undefined;

var _urls = require('../config/data/urls');

var _env = require('./env');

var _url = require('./url');

var isBrandApp = exports.isBrandApp = function isBrandApp() {
  return (0, _url.getHostName)() === _urls.brandAppBaseUrls[(0, _env.getDomain)()];
};
var isContentManagerApp = exports.isContentManagerApp = function isContentManagerApp() {
  return (0, _url.getHostName)() === _urls.contentManagerAppBaseUrls[(0, _env.getDomain)()];
};
var isProducerApp = exports.isProducerApp = function isProducerApp() {
  return (0, _url.getHostName)() === _urls.producerAppBaseUrls[(0, _env.getDomain)()];
};
var isCreatorApp = exports.isCreatorApp = function isCreatorApp() {
  return (0, _url.getHostName)() === _urls.creatorAppBaseUrls[(0, _env.getDomain)()];
};
var isMarketplaceApp = exports.isMarketplaceApp = function isMarketplaceApp() {
  return (0, _url.getHostName)() === _urls.marketplaceAppBaseUrls[(0, _env.getDomain)()];
};
var isManagerApp = exports.isManagerApp = function isManagerApp() {
  return (0, _url.getHostName)() === _urls.managerAppBaseUrls[(0, _env.getDomain)()];
};
var isVaasApp = exports.isVaasApp = function isVaasApp() {
  return (0, _url.getHostName)() === _urls.vaasBaseUrls[(0, _env.getDomain)()];
};
//# sourceMappingURL=app-type.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/helpers/app-type.js
// module id = 1927
// module chunks = 0